'use client';

import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { ContentTile } from '@/types/generated';

import { headerStyles } from './Header.styles';
import { CCNavLink } from './CCNavLink';

interface IContentTileImage {
	image?: {
		cdn_url?: string;
		url?: string;
	};
}

interface ContentTileCardProps {
	tile: ContentTile;
	onClick?: () => void;
}

const getTileHref = (tile: ContentTile): string => tile.internalPage?.path ?? tile.externalUrl ?? '#';

const getTileImageUrl = (tile: ContentTile): string => {
	const img = tile.image as unknown as IContentTileImage;
	return img?.image?.cdn_url ?? img?.image?.url ?? '';
};

const ContentTileCard = ({ tile, onClick }: ContentTileCardProps) => {
	const href = getTileHref(tile);
	const imageUrl = getTileImageUrl(tile);

	return (
		<CCNavLink href={href} title={tile.title || ''} dataTestId={`content_tile_${tile.sys?.id}`}>
			<Box sx={headerStyles.contentTileCard} onClick={onClick}>
				<Box
					role="img"
					aria-label={tile.title || ''}
					sx={{
						...(headerStyles.contentTileCardImage as object),
						...(imageUrl
							? {
									backgroundImage: `linear-gradient(0deg, rgba(244, 224, 206, 0.81) 0%, rgba(244, 224, 206, 0.81) 100%), url(${imageUrl})`,
							  }
							: {}),
					}}
				/>
				<Box sx={headerStyles.contentTileCardText}>
					<Typography sx={headerStyles.contentTileCardTitle}>{tile.title}</Typography>
					{tile.description && (
						<Typography sx={headerStyles.contentTileCardDescription}>{tile.description}</Typography>
					)}
				</Box>
				<ChevronRightIcon sx={headerStyles.contentTileCardChevron} />
			</Box>
		</CCNavLink>
	);
};

export default ContentTileCard;
